// src/hooks/useCartPricing.js
import { useEffect, useState, useRef } from "react";
import { fetchCartPricing } from "../utils/pricing";

/**
 * Given cart items [{id, qty, ...}], returns live wholesale pricing
 * keyed by product id, plus subtotal, loading state.
 */
export function useCartPricing(cartItems) {
  const [pricingMap, setPricingMap] = useState({});   // { [productId]: {...} }
  const [subtotal, setSubtotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const debounceRef = useRef(null);

  useEffect(() => {
    if (!cartItems.length) {
      setPricingMap({});
      setSubtotal(0);
      return;
    }

    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(async () => {
      setLoading(true);
      try {
        const payload = cartItems.map((i) => ({ product: i.id, quantity: i.qty }));
        const data = await fetchCartPricing(payload);
        const map = {};
        data.items.forEach((it) => { map[it.product_id] = it; });
        setPricingMap(map);
        setSubtotal(data.subtotal);
      } catch (e) {
        console.error("Pricing preview failed", e);
      } finally {
        setLoading(false);
      }
    }, 250); // debounce so qty +/- clicks don't spam the API

    return () => clearTimeout(debounceRef.current);
  }, [cartItems]);

  return { pricingMap, subtotal, loading };
}